import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import api, { formatApiErrorDetail } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please sign in");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Choose a new password" subtitle="Enter a new password for your account"
      footer={<Link className="text-[#8a6a1e] font-medium hover:underline" to="/login">Back to sign in</Link>}>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <Label htmlFor="password">New password</Label>
          <Input id="password" data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-white" />
        </div>
        <Button data-testid="reset-submit-button" disabled={loading || !token} className="w-full bg-[#101820] text-[#FAF6EE] rounded-full h-11">
          {loading ? "Updating…" : "Update password"}
        </Button>
        {!token && <p className="text-sm text-destructive">Missing reset token.</p>}
      </form>
    </AuthShell>
  );
}
